import { Component, Vue, Prop } from 'vue-property-decorator'

import { StarRating } from '../StarRating';
import { IDoctor, IPoint, IAddress, ILocation } from '../../models';
import { TemedMap } from '../TemedMap';
import { truncate, stripHtmlTags } from '../../utils/StringUtils';
import * as DistanceUtils from '../../utils/DistanceUtils';
import { EventBus, TEMED_WIDGET_EVENTS } from '../../services/EventBus';
import { AppService } from '../../services/AppService';

const TEMED_HOST = process.env.TEMED_HOST;
const CONSULT_HOST = process.env.CONSULT_HOST;

import './TemedDoctorDetails.scss';

@Component({
  template: require('./TemedDoctorDetails.html'),
  components:{
    'star-rating': StarRating,
    'temed-map': TemedMap
  },
  props:{
    mostRated: Boolean,
    item: Object
  }
})
export class TemedDoctorDetails extends Vue {

  temedHost: string = TEMED_HOST;
  consultHost: string = CONSULT_HOST;

  @Prop()
  linkText: 'See full doctor\'s profile'

  @Prop({ default: false })
  mostRated: boolean;

  @Prop()
  item: IDoctor;

  mapRef = null;

  moreOffices = false;

  userLocation: ILocation = null;

  protected appService: AppService;

  beforeMount(){
    this.mapRef = this.$refs.mapRef;
  }

  mounted () {
    this.appService = AppService.getInstance();
    this.userLocation = this.appService.get('userLocation');
    EventBus.$on(TEMED_WIDGET_EVENTS.GEO_LOCATION_CHANGED, () => {
      this.appService.getUserLocation()
        .then(location => {
          this.userLocation = location;
          this.$forceUpdate();
        }).catch(e => {
          console.log(e);
        });
    });
  }

  get doctorName(){
    return this.item.prefix+ ' ' + this.item.first_name + ' ' + this.item.last_name + ' ' + this.item.degree_credentials;
  }

  get doctorUrl(){
    return `${this.temedHost}/doctors/${this.item.slug}`
  }

  get practiceYear(){
    if(this.item.practice_year){
      const date = new Date();
      const practiceYear = parseInt(this.item.practice_year);
      return date.getFullYear() - practiceYear;
    }
    return ' - ';
  }

  get biography() {
    return truncate(stripHtmlTags(this.item.biography), 500);
  }

  get reviewText() {
    return truncate(stripHtmlTags(this.item.expertise), 260);
  }

  calcDistance(office: IAddress){
    if(this.userLocation && this.userLocation.latitude && this.userLocation.longitude){
      const officePoint: IPoint = { latitude: office.latitude, longitude: office.longitude };
      return DistanceUtils.getDistanseMiles(this.userLocation, officePoint);
    }
    return null;
  }

  serviceUrl(section: string, name: string){
    const slug = name.replace(' ', '-')
    return `${this.temedHost}/doctors?${section}=${slug}`
  }


}
